const AGGREGATE_CALC = 'aggregate_calc';
const ALL_CALC = 'all_calc';
const COMPANY_CALC = 'company_calc';
const FUND_CALC = 'fund_calc';
const FUND_HISTORY_CALC = 'fund_history_calc';
const HISTORY_CALC = 'history_calc';
const INDEX_CALC = 'index_calc';
const STOCK_CALC = 'stock_calc';
export { AGGREGATE_CALC, ALL_CALC, COMPANY_CALC, FUND_CALC, FUND_HISTORY_CALC, HISTORY_CALC, INDEX_CALC, STOCK_CALC };
